import { jsxs as s, jsx as t, Fragment as k } from "react/jsx-runtime";
import { forwardRef as r, useRef as S } from "react";
import { Field as c } from "./es/components/Field/Field.js";
import { c as y } from "./index-Cu0xwYjD.js";
import "./es/components/Accordion/Accordion.js";
import "./es/components/ActionList/ActionList.js";
import "./create-theme-C4Hb_-Ag.js";
import "./es/components/Checkbox/Checkbox.js";
import "./es/components/Button/Button.js";
import { VisuallyHidden as q } from "./es/components/VisuallyHidden/VisuallyHidden.js";
import "./es/components/DataTable/DataTable.js";
import { ErrorText as V } from "./es/components/ErrorText/ErrorText.js";
import { FormGroup as G } from "./es/components/FormGroup/FormGroup.js";
import { HintText as H } from "./es/components/HintText/HintText.js";
import { LabelText as j } from "./es/components/LabelText/LabelText.js";
import { Stack as w } from "./es/components/Stack/Stack.js";
import { SubLabelText as $ } from "./es/components/SubLabelText/SubLabelText.js";
import "./es/components/Disclosure/Disclosure.js";
import "./es/components/Link/Link.js";
import "./es/components/Notification/Notification.js";
import { Icon as B } from "./es/components/Icon/Icon.js";
import { useTogglePasswordVisibility as A, PasswordVisibilityToggle as U } from "./es/components/PasswordInput/PasswordVisibilityToggle.js";
import "./es/components/Radio/Radio.js";
import { callAll as M } from "./es/utils/utils.js";
import "./index-BvW_Fyli.js";
import "./es/components/Toggle/Toggle.js";
import "./es/components/RadioCard/RadioCard.js";
import { IconsProvider as Y } from "./es/providers/IconsProvider.js";
import "./es/providers/PictogramsProvider.js";
import "./ThemeContext-CvPyrdCo.js";
import { s as p, C as N } from "./CurrencyTextIcon-D9YddTD9.js";
import './assets/DatePickerField.css';const u = r(
  ({
    as: e = "input",
    iconLeft: a,
    iconRight: i,
    rightSlot: l,
    inputClassName: m,
    wrapperClassName: d,
    iconClassName: h,
    "data-error": n,
    "aria-invalid": o,
    ...f
  }, b) => /* @__PURE__ */ s("div", { className: y(p.wrapper, d), children: [
    a ? /* @__PURE__ */ t(
      Y,
      {
        icons: {
          pound: () => N("£"),
          euro: () => N("€"),
          dollar: () => N("$")
        },
        children: /* @__PURE__ */ t(
          B,
          {
            className: y(p.icon, p.left, h),
            name: a,
            size: 16,
            pointerEvents: "none",
            "data-error": n,
            "aria-invalid": o
          }
        )
      }
    ) : null,
    /* @__PURE__ */ t(
      e,
      {
        className: y(
          p.input,
          {
            [p.hasLeftSlot]: !!a,
            [p.hasRightSlot]: !!i || !!l
          },
          m
        ),
        "data-error": n,
        "aria-invalid": o,
        ...f,
        ref: b
      }
    ),
    i && !l ? /* @__PURE__ */ t(
      B,
      {
        className: y(p.icon, p.right, h),
        name: i,
        size: 16,
        pointerEvents: "none",
        "data-error": n,
        "aria-invalid": o
      }
    ) : null,
    l
  ] })
), g = r(
  ({ inputMode: e = "numeric", ...a }, i) => /* @__PURE__ */ t(
    u,
    {
      ...a,
      type: "text",
      inputMode: e,
      pattern: "[0-9]*",
      autoCapitalize: "none",
      autoCorrect: "off",
      spellCheck: "false",
      ref: i
    }
  )
), J = r(
  ({
    id: e,
    "aria-describedby": a,
    "aria-invalid": i,
    currency: l = "GBP",
    inputMode: m = "decimal",
    ...d
  }, h) => {
    const n = `${e}-describedby`, o = `${a || ""} ${n}`.trim();
    return /* @__PURE__ */ s(k, { children: [
      /* @__PURE__ */ t(q, { id: n, "aria-hidden": "true", children: l === "GBP" ? "pounds" : l === "EUR" ? "euro" : "dollar" }),
      /* @__PURE__ */ t(
        g,
        {
          id: e,
          "aria-describedby": o,
          "aria-invalid": i,
          iconLeft: l === "GBP" ? "pound" : l === "EUR" ? "euro" : "dollar",
          inputMode: m,
          ...d,
          ref: h
        }
      )
    ] });
  }
), je = r(({ ...e }, a) => /* @__PURE__ */ t(c, { affixWidth: 40, ...e, children: /* @__PURE__ */ t(J, { ref: a }) })), K = "_inlineFields_11q39_4", Q = "_fullWidth_11q39_13", X = "_dayField_11q39_27", Z = "_monthField_11q39_31", O = "_yearField_11q39_35", v = {
  inlineFields: K,
  fullWidth: Q,
  dayField: X,
  monthField: Z,
  yearField: O
}, Ae = r(
  ({
    id: e,
    autoFocusNext: a = !0,
    name: i,
    label: l,
    hint: m,
    error: d,
    optional: h = !1,
    fullWidth: n = !1,
    readOnly: o = !1,
    value: f = {
      day: "",
      month: "",
      year: ""
    },
    onChange: b,
    "data-testid": F
  }, L) => {
    const _ = !!d, I = S(null), P = S(null), W = {
      day: I,
      month: P
    }, x = (C) => (D) => {
      if (b && b({
        ...f,
        [C]: D.target.value
      }), C !== "year" && a) {
        const R = W[C].current;
        R && D.target.value.length === 2 && R.focus();
      }
    }, z = `${e}-month`, T = `${e}-year`;
    return /* @__PURE__ */ t(G, { "data-error": _ || void 0, children: /* @__PURE__ */ s("fieldset", { children: [
      /* @__PURE__ */ s("legend", { children: [
        /* @__PURE__ */ s(j, { children: [
          l,
          h ? " (optional)" : null
        ] }),
        m ? /* @__PURE__ */ t(H, { children: m }) : null,
        /* @__PURE__ */ t(
          "div",
          {
            id: `error-${e}`,
            role: "alert",
            style: _ ? {} : { margin: 0 },
            children: d ? /* @__PURE__ */ t(V, { children: d }) : null
          }
        )
      ] }),
      /* @__PURE__ */ s(
        "div",
        {
          className: y(v.inlineFields, {
            [v.fullWidth]: n
          }),
          children: [
            /* @__PURE__ */ s(w, { className: v.dayField, spaceBetween: 1, children: [
              /* @__PURE__ */ t($, { htmlFor: e, id: "label-day", children: "Day" }),
              /* @__PURE__ */ t(
                g,
                {
                  ref: L,
                  id: e,
                  "data-testid": F,
                  name: i,
                  "aria-invalid": _ || void 0,
                  "aria-labelledby": `label-day error-${e}`,
                  value: f.day,
                  readOnly: o,
                  onChange: x("day")
                }
              )
            ] }),
            /* @__PURE__ */ s(w, { className: v.monthField, spaceBetween: 1, children: [
              /* @__PURE__ */ t($, { htmlFor: z, id: "label-month", children: "Month" }),
              /* @__PURE__ */ t(
                g,
                {
                  id: z,
                  "data-testid": F && `${F}-month`,
                  name: i && `${i}-month`,
                  "aria-invalid": _ || void 0,
                  "aria-labelledby": `label-month error-${e}`,
                  value: f.month,
                  readOnly: o,
                  onChange: x("month"),
                  ref: I
                }
              )
            ] }),
            /* @__PURE__ */ s(w, { className: v.yearField, spaceBetween: 1, children: [
              /* @__PURE__ */ t($, { htmlFor: T, id: "label-year", children: "Year" }),
              /* @__PURE__ */ t(
                g,
                {
                  id: T,
                  "data-testid": F && `${F}-year`,
                  name: i && `${i}-year`,
                  "aria-invalid": _ || void 0,
                  "aria-labelledby": `label-year error-${e}`,
                  value: f.year,
                  readOnly: o,
                  onChange: x("year"),
                  ref: P
                }
              )
            ] })
          ]
        }
      )
    ] }) });
  }
), ee = r((e, a) => /* @__PURE__ */ t(
  u,
  {
    ...e,
    type: "email",
    autoCapitalize: "none",
    autoCorrect: "off",
    spellCheck: "false",
    ref: a
  }
)), Ue = r(
  ({ ...e }, a) => /* @__PURE__ */ t(c, { ...e, children: /* @__PURE__ */ t(ee, { ref: a }) })
), Me = r(({ ...e }, a) => /* @__PURE__ */ t(c, { ...e, children: /* @__PURE__ */ t(g, { ref: a }) })), te = r((e, a) => {
  const { isPasswordVisible: i, handlePasswordVisibility: l } = A();
  return /* @__PURE__ */ t(
    u,
    {
      ...e,
      rightSlot: e.hasVisibilityToggle ? /* @__PURE__ */ t(
        U,
        {
          testId: "password-input-visibility-toggle",
          iconName: i ? "hide" : "show",
          handlePasswordVisibility: l,
          visibilityToggleLabel: i ? "Hide password" : "Show password"
        }
      ) : null,
      type: i ? "text" : "password",
      autoCapitalize: "none",
      autoCorrect: "off",
      spellCheck: "false",
      ref: a
    }
  );
}), Ye = r(({ hasVisibilityToggle: e, ...a }, i) => /* @__PURE__ */ t(c, { ...a, children: /* @__PURE__ */ t(te, { ref: i, hasVisibilityToggle: e }) })), ae = r((e, a) => /* @__PURE__ */ t(
  u,
  {
    ...e,
    type: "tel",
    autoCapitalize: "none",
    autoCorrect: "off",
    spellCheck: "false",
    ref: a
  }
)), Je = r(
  ({ ...e }, a) => /* @__PURE__ */ t(c, { ...e, children: /* @__PURE__ */ t(ae, { ref: a }) })
), ie = "_select_cpotg_4", re = {
  select: ie
}, le = r(
  ({
    options: e,
    children: a,
    onChange: i,
    onValueChange: l,
    "aria-invalid": m,
    ...d
  }, h) => /* @__PURE__ */ s(
    u,
    {
      ...d,
      as: "select",
      inputClassName: re.select,
      iconRight: "chevron-down",
      "aria-invalid": m,
      onChange: M(
        l && ((n) => l(n.currentTarget.value)),
        i
      ),
      ref: h,
      children: [
        e ? e.map(({ value: n, label: o }) => /* @__PURE__ */ t("option", { value: n, children: o }, n)) : null,
        a
      ]
    }
  )
), Ke = r(({ children: e, ...a }, i) => /* @__PURE__ */ t(c, { affixWidth: 40, ...a, children: /* @__PURE__ */ t(le, { ref: i, children: e }) })), ne = "_textarea_1ffw0_4", oe = "_resizable_1ffw0_12", E = {
  textarea: ne,
  resizable: oe
}, se = r(
  ({ rows: e = 3, resizable: a = !1, ...i }, l) => /* @__PURE__ */ t(
    u,
    {
      ...i,
      as: "textarea",
      inputClassName: y(E.textarea, {
        [E.resizable]: a
      }),
      rows: e,
      ref: l
    }
  )
), Qe = r(({ ...e }, a) => /* @__PURE__ */ t(c, { ...e, children: /* @__PURE__ */ t(se, { ref: a }) })), de = r((e, a) => /* @__PURE__ */ t(u, { ...e, type: "text", ref: a })), Xe = r(
  ({ ...e }, a) => /* @__PURE__ */ t(c, { ...e, children: /* @__PURE__ */ t(de, { ref: a }) })
), ce = "_hiddenDefaultIcon_magvr_1", me = {
  hiddenDefaultIcon: ce
}, Ze = r(({ ...e }, a) => /* @__PURE__ */ t(c, { ...e, children: /* @__PURE__ */ t(
  u,
  {
    inputClassName: me.hiddenDefaultIcon,
    iconRight: "cal",
    type: "date",
    ref: a
  }
) }));
export {
  je as C,
  Ae as D,
  Ue as E,
  u as I,
  Me as N,
  Ye as P,
  Ke as S,
  Qe as T,
  J as a,
  ee as b,
  g as c,
  te as d,
  Je as e,
  ae as f,
  le as g,
  se as h,
  Xe as i,
  de as j,
  Ze as k
};
